import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Cookies from "js-cookie";

import axios from 'axios'
import VueAxios from 'vue-axios'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Icon from 'vue-awesome/components/Icon'

import 'vue-awesome/icons/trash'
import 'vue-awesome/icons/edit'
import 'vue-awesome/icons/user-edit'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/coins'
import 'vue-awesome/icons/hand-holding-usd'
import 'vue-awesome/icons/wallet'
import 'vue-awesome/icons/user-check'
import 'vue-awesome/icons/user-times'
import 'vue-awesome/icons/times-circle'
import 'vue-awesome/icons/check-circle'
import 'vue-awesome/icons/share-square'
import 'vue-awesome/icons/paper-plane'
import 'vue-awesome/icons/file-alt'
import 'vue-awesome/icons/arrow-left'
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/clipboard-list'
import 'vue-awesome/icons/bell'
import 'vue-awesome/icons/check'



// globally (in your main .js file)
Vue.component('v-icon', Icon)

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueAxios, axios)

axios.interceptors.request.use(function(config) {
  config['headers'] = {      
   'Authorization': 'Bearer ' + Cookies.get('access_token'),
  };
  return config;
}, error => Promise.reject(error));
 
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
